import { render } from "./IntercomAdvantage.vue?vue&type=template&id=48e11c85&scoped=true"
import script from "./IntercomAdvantage.vue?vue&type=script&lang=js"
export * from "./IntercomAdvantage.vue?vue&type=script&lang=js"

import "./IntercomAdvantage.vue?vue&type=style&index=0&id=48e11c85&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e11c85"]])

export default __exports__